<button [class]="'button _cancel ' + fromSize(size) + ' ' + fromRole(role)" type="button"
        [class._disabled]="disabled" (click)="doAction($event)">
    <div (click)="doAction($event)">
        <ng-content></ng-content>
    </div>
</button>
